import { render } from "./HomeCerebroDigital.vue?vue&type=template&id=5b4e02ae&scoped=true"
import script from "./HomeCerebroDigital.vue?vue&type=script&lang=js"
export * from "./HomeCerebroDigital.vue?vue&type=script&lang=js"

import "./HomeCerebroDigital.vue?vue&type=style&index=0&id=5b4e02ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b4e02ae"]])

export default __exports__